import React from 'react';
import Button from '@material-ui/core/Button';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import apiClient, { getAccessToken, getSessionUser } from '../../apiClient';
import './LoginForm.scss';
import { Redirect } from 'react-router-dom';
import withFlashNotification from '../Notification/withFlashNotification';
import { notifyApiError } from '../Notification/notificationHelpers';



class LoginForm extends React.Component {

   
  
    constructor(props) {
        super(props)
        this.state = {
            formData: {
                email: '',
                password: '',
                isLoggedIn: false,
                accessToken: ''
            },
            submitted: false,
            successMessage: null,
        };

       
    }
    
   componentDidMount() {
    const authMessage = sessionStorage.getItem('authMessage');
    if (authMessage) {
      sessionStorage.removeItem('authMessage');
      this.setState({ successMessage: authMessage });
    }
    this.storeCollector();
   }

   storeCollector() {
       const user = getSessionUser();
       if(user && user.isLoggedIn) {
           this.setState({isLoggedIn: true, accessToken: user.accessToken});
       }
   }

    handleChange = (event) => {
        const { formData } = this.state;
        formData[event.target.name] = event.target.value;
        this.setState({ formData });
    }

   

    handleSubmit = () => {
        this.setState({ submitted: true }, () => {
            setTimeout(() => this.setState({ 
                formData: {
                    email: '',
                    password: '',
                },
                submitted: false
             }), 5000);
        });
        /**
         * POST REQUEST
         */
        const { formData } = this.state;
        apiClient.post(`/api/post/login`, { formData })
      .then(res => {
        const payload = res.data;
        const users = payload && payload.users;
        const accessToken = (payload && payload.accessToken) || '';
        if (users && users.length > 0)
        {
            this.setState({ result: users });

              const params = {
                roleid:  (users[0].UserType == 'admin'? 1:2) ,
                };
        
        
              apiClient.get(`/api/get/permission`, {params: params , headers: {"Authorization" : `Bearer ${accessToken}`} })
              .then(permRes => {
                const Results = permRes.data;
                sessionStorage.setItem('user', JSON.stringify({
                    isLoggedIn: true,
                    userId: users[0].UserID,
                    userName: users[0].Name,
                    role: users[0].UserType,
                    permissions : Results,
                    accessToken
                }));
                sessionStorage.setItem('TranSearch', null);
                sessionStorage.setItem('ItemTabIndex', JSON.stringify(0));
                this.storeCollector();
              })
              .catch(error => notifyApiError(
                this.props.showFlashNotification,
                error,
                'Unable to load account permissions.'
              ));

        }else{
            this.setState({ successMessage: 'Invalid Email or Password' });

                setTimeout(() => {
                this.setState({ successMessage: null });
                }, 3000);
        }
         
      })
      .catch(err => {
        const message = err.response && err.response.status === 401
          ? 'Invalid Email or Password'
          : 'Unable to log in. Please try again.';
        this.setState({ successMessage: message });
        this.props.showFlashNotification(message, 'error');
        setTimeout(() => {
          this.setState({ successMessage: null });
        }, 3000);
      });
    }

    componentPopulatePermissions(value) {
        let accessToken = getAccessToken();
  
        
          const params = {
            roleid:  value ,
            };
    
    
          apiClient.get(`/api/get/permission`, {params: params , headers: {"Authorization" : `Bearer ${accessToken}`} })
          .then(res => {
            const Results = res.data;
            this.setState({ Results });
          })
          .catch(error => notifyApiError(
            this.props.showFlashNotification,
            error,
            'Unable to load account permissions.'
          ));

        
      }

    render() {
        /**
         * Redirect to Home Page
         */
        if(this.state.isLoggedIn) {
            return <Redirect to="/home" />
        }
        const { formData, submitted } = this.state;
        return (
          <div className="login-page">
            <div className="login-card">
              <div className="login-brand">alfaSUITE</div>
              <h2 className="login-title">Log in to your account</h2>
              <ValidatorForm ref="form" onSubmit={this.handleSubmit} className="login-form">
                <TextValidator
                  className="login-field"
                  label="User Name"
                  onChange={this.handleChange}
                  name="email"
                  value={formData.email}
                  validators={['required']}
                  errorMessages={['This field is required']}
                  variant="outlined"
                  fullWidth
                />
                <TextValidator
                  className="login-field"
                  label="Password"
                  onChange={this.handleChange}
                  name="password"
                  type="password"
                  value={formData.password}
                  validators={['required']}
                  errorMessages={['This field is required']}
                  variant="outlined"
                  fullWidth
                />
                <Button
                  className="login-submit"
                  color="primary"
                  variant="contained"
                  size="large"
                  type="submit"
                  disabled={submitted}
                  fullWidth
                >
                  {submitted ? 'Signing in…' : 'Sign in'}
                </Button>
                {this.state.successMessage && (
                  <div className="login-error">{this.state.successMessage}</div>
                )}
              </ValidatorForm>
            </div>
          </div>
        );
    }
}

export { LoginForm };
export default withFlashNotification(LoginForm);
